module.exports = __webpack_public_path__ + "img/car-4.64dd97df.jpg";